import { openPremiumPage } from '../../../common/utils/promocode'
import { useNavigate } from 'react-router-dom'
import IconCrownWhite from "../svg_icons/IconCrownWhite";
import {Button, Flex} from "antd";

const AddPremiumButtonInProfile = () => {
    const navigate = useNavigate()

    const openPremium = () => {
        openPremiumPage(navigate)
    }

    return (
        <Flex style={{ marginTop: '16px' }}>
            <Button  color="purple" variant="solid"  size="large" onClick={openPremium} icon={<IconCrownWhite/>}>
                Подключить премиум
            </Button>
        </Flex>
    )
}

export default AddPremiumButtonInProfile
